import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import { Labels } from '../../global/labels';
import { element } from '../../global/template-literals';
import type { TranslationLabels } from '../../types/labels.type';
import styles from './ui-skip-to-content.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @classdesc Represents a class for <code>ui-skip-to-content</code> element.
 * @alias UISkipToContent
 * @element ui-skip-to-content
 * @property {string} [href="#page"] {@attr href} A URL to an anchor to skip to. Must start with `#`.
 * <ui-skip-to-content href="#main-content">
 * </ui-skip-to-content>
 */
@Component({ tag: 'ui-skip-to-content', styles })
export class UISkipToContent extends UIElement {
    /**
     * Define labels what could be localised
     * @type {Labels}
     * @readonly
     */
    static get labels(): TranslationLabels.Labels {
        return Labels.attach('ui-skip-to-content', {
            linkLabel: 'Skip to main content',
        });
    }

    @Attribute(String) href: string = '#page';

    /**
     * Renders link element template.
     * @private
     * @returns {HTMLElement}
     */
    private renderTemplate(): HTMLElement {
        return element`<a
            class="ui-skip-to-content__link"
            href="${this.href}"
            >${UISkipToContent.labels.linkLabel}</a
        >`;
    }

    /**
     * @inheritDoc
     */
    override render(): void {
        this.insertElements([this.renderTemplate()]);
    }

    /**
     * @inheritDoc
     */
    override hydrate(): void {}
}
